import React from 'react';
import Lottie from 'react-lottie';
import './Terms_And_Condition_Lottie.css';
import * as animationData from './Terms_And_Condition_Lottie.json';

function Terms_And_Condition_Lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <section className='main'>
      <div className='Support_lottie_icon'>
        <Lottie className="me-auto"
          options={defaultOptions}
        // height={60}
        // width={60}          
        />
      </div>
    </section>
  );
}
export default Terms_And_Condition_Lottie;